import {
  ActionSheetContext,
  ActionSheetV2,
  Button,
  Description,
  Icon,
  ListItem,
  MdPadding,
  XxsSpacing,
} from '@alto/design-system';
import React, { useContext } from 'react';
import { getImage } from '~shared/assets/images/getImage';
import { IMG_ALT_TEXTS } from '~shared/constants';
import { useFetchAncillariesByPrescriptionId } from '../queries/queries';

type Props = {
  readonly onBack?: () => void;
  readonly onPress?: () => void;
  readonly prescriptionID: number;
};

export const AncillaryItemsActionSheet = ({ onBack, onPress, prescriptionID }: Props) => {
  const { ancillaries } = useFetchAncillariesByPrescriptionId({ prescriptionId: prescriptionID });
  const { closeActionSheet } = useContext(ActionSheetContext);

  return (
    <ActionSheetV2
      title="This medication includes complimentary supplies"
      analyticsName="checkout ancillary items"
      illustrationSrc={getImage('syringe')}
      illustrationAccessibilityLabel={IMG_ALT_TEXTS.syringe}
      handleBack={onBack}
      handleClose={onBack}
      buttons={[
        <Button
          key="got-it"
          label="Got it"
          onPress={onPress ?? closeActionSheet}
        />,
      ]}
    >
      <MdPadding>
        <ListItem
          title="Supplies included:"
          LeftContent={<Icon name="syringe-duo" />}
          fullBleed
          descriptions={ancillaries.map((ancillary) => {
            return (
              <>
                <XxsSpacing />
                <Description key={ancillary.description}>• {ancillary.description}</Description>
              </>
            );
          })}
        />
      </MdPadding>
    </ActionSheetV2>
  );
};
